import React, { useState } from "react";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import { Col, Row } from "reactstrap";
import SettingsIcon from "@material-ui/icons/Settings";
import GetAppIcon from "@material-ui/icons/GetApp";
import axios from "axios";
import fileSaver from "file-saver";
import { Tooltip } from "@material-ui/core";
import RotateLeftIcon from "@material-ui/icons/RotateLeft";
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";
import ConfirmModal from "../../../../components/ConfirmModal/ConfirmModal";
import { HowToVote } from "@material-ui/icons";
import MoodIcon from "@material-ui/icons/Mood";
import EventNoteIcon from "@material-ui/icons/EventNote";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import { PopList } from "./other/PopList";
import MobileFriendlyIcon from "@material-ui/icons/MobileFriendly";
import MeetingRoomIcon from "@material-ui/icons/MeetingRoom";
import AllInboxIcon from "@material-ui/icons/AllInbox";
import { securityHelper } from "../../../../helpers/securityHelper";
import ViewCompactIcon from "@material-ui/icons/ViewCompact";
import LayoutDialog from "./LayoutDialog";
import MeetingLayoutSettings from "./Settings/MeetingLayoutSettings/MeetingLayoutSettings";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import CheckIcon from "@material-ui/icons/Check";
import RateReviewIcon from "@material-ui/icons/RateReview";
import JirangoSwitch from "../../../../components/JirangoSwitch/JirangoSwitch";
import OpenInNewOutlinedIcon from "@material-ui/icons/OpenInNewOutlined";
import EventBusyIcon from "@material-ui/icons/EventBusy";
import FilterDramaIcon from "@material-ui/icons/FilterDrama";
import ViewHeadlineIcon from "@material-ui/icons/ViewHeadline";
import BarChartIcon from "@material-ui/icons/BarChart";
import PieChartIcon from "@material-ui/icons/PieChart";
import TableChartIcon from "@material-ui/icons/TableChart";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import BrokenImageIcon from '@material-ui/icons/BrokenImage';

const customStyles = {
  control: (provided, state) => ({
    ...provided,

    backgroundColor: "#535562",
    color: "#eee",
    border: "0px",
    maxWidth: "100%",
  }),
  noOptionsMessage: (provided, state) => ({
    ...provided,
    color: "green",
    maxWidth: "100%",
  }),
  input: (provided, state) => ({
    ...provided,
    color: "#eee",
    maxWidth: "100%",
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: "#eee",
  }),
  indicatorSeparator: (provided, state) => ({
    ...provided,
    background: "transparent",
  }),
  menu: (provided, state) => ({
    ...provided,
    backgroundColor: "#3d3d3d",
    maxWidth: "100%",
    zIndex: 100,
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#20a8d8" : "#535562",
    color: "#eee",
    ["&:hover"]: {
      backgroundColor: "#5a5959ba",
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#eee",
  }),
};

export default function HeaderBar(props) {
  const [asideOpen, setAsideOpen] = useState(false);
  const [modalOpen, setModal] = useState(false);
  const { eventId, presenterSettings } = props;

  const exportParticipantExcel = () => {
    axios
      .get(`./api/InteractionReport/participant/${eventId}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        var blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        var date = new Date();
        var datestr = `${date.getFullYear()}-${date.getMonth() + 1 < 10 ? "0" : ""}${date.getMonth() + 1}-${date.getDate() < 10 ? "0" : ""}${date.getDate()}_${date.getHours() < 10 ? "0" : ""
          }${date.getHours()}${date.getMinutes() < 10 ? "0" : ""}${date.getMinutes()}`;

        var fileName = `${props.eventName}_Deltagarstatistik_${datestr}.xlsx`;
        fileSaver.saveAs(blob, fileName);
      });
  };
  const exportActiveParticipantExcel = () => {
    axios
      .get(`./api/InteractionReport/activeparticipant/${eventId}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        var blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        fileSaver.saveAs(blob, "active_" + new Date().toLocaleString() + ".xlsx");
      });
  };
  const reset = () => {
    props.clearEventData();
    toggleModal();
  };
  const toggleModal = () => {
    setModal(!modalOpen);
  };
  
  const textPresenterTypes = [
    // { value: "NONE", label: <SystemLabel name="None" /> },
    { value: "WORDCLOUD", label: <SystemLabel name="WordCloud" />, icon: <FilterDramaIcon /> },
    { value: "TEXTFLOW", label: <SystemLabel name="TextFlow" />, icon: <ViewHeadlineIcon /> },
  ];
  const optionPresenterTypes = [
    // { value: "NONE", label: <SystemLabel name="None" /> },
    { value: "BARCHART", label: <SystemLabel name="BarChart" />, icon: <BarChartIcon style={{ transform: "rotate(90deg)" }} /> },
    { value: "COLUMNCHART", label: <SystemLabel name="ColumnChart" />, icon: <BarChartIcon /> },
    { value: "PIECHART", label: <SystemLabel name="PieChart" />, icon: <PieChartIcon /> },
    { value: "DISPARITYCHART", label: <SystemLabel name="DisparityChart" />, icon: <TableChartIcon /> },
    // { value: "LINECHART", label: <SystemLabel name="LineChart" />, icon: <ShowChartIcon /> },
  ];

  const updatePresenterSettings = (target, value) => {
    const updatedSettings = { ...presenterSettings };
    updatedSettings[target] = value;
    props.updatePresenterSettings(updatedSettings);
  };

  const { templates, eventCode, clientTemplateId, breakouts, hubConnection } = props;
  return (
    <AppBar
      style={{
        backgroundColor: props.activeModulesChanged ? "red" : "#222",
        minHeight: "54px",
        maxHeight: "54px",
      }}
      position="static"
    /*     onClick={() => props.toggleAside(false)} */
    >
      <Toolbar
        style={{
          backgroundColor: props.activeModulesChanged ? "#cb1f1f" : "#222",
          minHeight: "54px",
          maxHeight: "54px",
        }}
      >
        <Col className="col-5" sm={5}>
          {props.parentEvent && props.parentEvent.eventId != props.eventId ? (
            <Typography
              className="ellipsis"
              variant="p"
              style={{
                color: "#ddd",
              }}
            >
              {props.parentEvent.name}
            </Typography>
          ) : null}

          <Typography
            variant="h6"
            className="ellipsis"
            style={{
              color: "#fff",
            }}
          >
            {props.parentEvent && props.parentEvent.eventId != props.eventId ? (
              <EventNoteIcon
                style={{
                  background: "#2098c2",
                  borderRadius: "50%",
                  padding: "4px",
                }}
              />
            ) : null}
            {"  "}
            {props.eventName}
          </Typography>
        </Col>
        {/*   <Col className="col-4 text-center inline-flex ">
        </Col> */}
        <Col className="col-7 text-right" sm={7} style={{ padding: 0 }}>
          {props.activeModulesChanged ? (
            <div className="module-changed-warning-w">
              <ErrorOutlineIcon />
              {"  "} <SystemLabel name="NewChangesHasBeenSavedReloadThePage" />
            </div>
          ) : null}
          <button
            className="moderator-page-to-btn"
            onClick={() =>
              window.open(
                `${window.location.origin}${!window.location.toString().includes("localhost") ? "/interaction" : ""}/channels/${props.parentEvent?.code || eventCode}?clientkey=${props.tickCode}${securityHelper.createGuid()}`,
                "_blank"
              )
            }
          >
            {" "}
            <BrokenImageIcon style={{ marginRight: 6 }} className="pop-list-icon" /> <SystemLabel name="ChannelListBtn" />
          </button>
          <button
            className="moderator-page-to-btn"
            onClick={() => window.open(`${window.location.origin}${!window.location.toString().includes("localhost") ? "/interaction" : ""}/presenter/${eventCode}?lang=${props.lang}`, "_blank")}
          >
            <BarChartIcon className="pop-list-icon" />
            <SystemLabel name="PresenterPage" />
          </button>

          <PopList
            tooltipText={"PresentationSettings"}
            icon={
              <React.Fragment>
                <SettingsIcon />
                <ArrowDropDownIcon />{" "}
              </React.Fragment>
            }
          >
            <div className="pop-list" style={{ minWidth: 300, maxWidth: 310 }}>
              <Row>
                <Col>
                  <div
                    className="list-option"
                    style={{ opacity: "0.7", cursor: "default" }}
                  // onClick={() => window.open(`${window.location.origin}${!window.location.toString().includes("localhost") ? "/interaction" : ""}/${b.link}`, "_blank")}
                  >
                    <SystemLabel name="TextPresenterTypes" />
                  </div>
                </Col>
              </Row>
              <hr className="thin-hr" />
              {textPresenterTypes.map((b, i) => {
                return (
                  <React.Fragment key={i}>
                    <Row>
                      <Col>
                        <div className="list-option" style={{ marginLeft: 10 }} onClick={() => updatePresenterSettings("displayTypeText", b.value)}>
                          {b.icon} {b.label} {b.value == presenterSettings.displayTypeText ? <CheckIcon /> : null}
                        </div>
                      </Col>
                    </Row>
                    <hr className="thin-hr" />
                  </React.Fragment>
                );
              })}
              <Row>
                <Col>
                  <div
                    className="list-option"
                    style={{ opacity: "0.7", cursor: "default" }}
                  // onClick={() => window.open(`${window.location.origin}${!window.location.toString().includes("localhost") ? "/interaction" : ""}/${b.link}`, "_blank")}
                  >
                    <SystemLabel name="OptionPresenterTypes" />
                  </div>
                </Col>
              </Row>
              <hr className="thin-hr" />
              {optionPresenterTypes.map((b, i) => {
                return (
                  <React.Fragment key={i}>
                    <Row>
                      <Col>
                        <div className="list-option" onClick={() => updatePresenterSettings("displayTypeOption", b.value)} style={{ marginLeft: 10 }}>
                          {b.icon} {b.label} {b.value == presenterSettings.displayTypeOption ? <CheckIcon /> : null}
                        </div>
                      </Col>
                    </Row>
                    <hr className="thin-hr" />
                  </React.Fragment>
                );
              })}
              <Row style={{ margin: "0px" }}>
                <Col style={{ padding: "0px" }}>
                  <div className="list-option">
                    <Row>
                      <Col className="col-8" style={{ display: "flex" }}>
                        {/* <BarChartOutlinedIcon className="pop-list-icon" /> */}
                        <SystemLabel name="PresentationOrderOnVotes" />
                      </Col>
                      <Col className="text-right">
                        <JirangoSwitch
                          onChange={() => updatePresenterSettings("presentationOrder", presenterSettings.presentationOrder == "SORTORDER" ? "VOTES" : "SORTORDER")}
                          isChecked={props.presentationOrder == "VOTES"}
                        />
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
              <Row style={{ margin: "0px" }}>
                <Col style={{ padding: "0px" }}>
                  <div className="list-option">
                    <Row>
                      <Col className="col-8" style={{ display: "flex" }}>
                        {/* <BarChartOutlinedIcon className="pop-list-icon" /> */}
                        {/* Grafer - Visa procent */}
                        <SystemLabel name="PresentationDiagramShowPercent" />
                      </Col>
                      <Col className="text-right">
                        <JirangoSwitch onChange={() => updatePresenterSettings("showPercent", !presenterSettings.showPercent)} isChecked={presenterSettings.showPercent} />
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
              <Row style={{ margin: "0px" }}>
                <Col style={{ padding: "0px" }}>
                  <div className="list-option">
                    <Row>
                      <Col className="col-8" style={{ display: "flex" }}>
                        {/* <BarChartOutlinedIcon className="pop-list-icon" /> */}
                        {/* Grafer - Visa antal */}
                        <SystemLabel name="PresentationDiagramShowCount" />
                      </Col>
                      <Col className="text-right">
                        <JirangoSwitch onChange={() => updatePresenterSettings("showCount", !presenterSettings.showCount)} isChecked={presenterSettings.showCount} />
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
              <hr className="thin-hr" />
              <Row style={{ margin: "0px" }}>
                <Col style={{ padding: "0px" }}>
                  <div className="list-option">
                    <Row>
                      <Col className="col-9" style={{ display: "flex" }}>
                        {/* <VerifiedUserIcon className="pop-list-icon" /> */}
                        <SystemLabel name="ModeratorMode" />
                      </Col>
                      <Col className="text-right">
                        <JirangoSwitch onChange={() => updatePresenterSettings("moderationMode", !presenterSettings.moderationMode)} isChecked={presenterSettings.moderationMode} />
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
              <hr className="thin-hr" />
              <Row style={{ margin: "0px" }}>
                <Col style={{ padding: "0px" }}>
                  <div className="list-option">
                    <Row>
                      <Col className="col-9" style={{ display: "flex" }}>
                        <SystemLabel name="TextShowNames" />
                      </Col>
                      <Col className="text-right">
                        <JirangoSwitch onChange={() => updatePresenterSettings("showNamesTextflow", !presenterSettings.showNamesTextflow)} isChecked={presenterSettings.showNamesTextflow} />
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </div>
          </PopList>

          <span style={{ margin: "0px 10px", color: "#d2d5d3F" }}>|</span>
          <button
            className="moderator-page-to-btn"
            onClick={() => window.open(`${window.location.origin}${!window.location.toString().includes("localhost") ? "/interaction" : ""}/session/stage/${eventCode}?lang=${props.lang}`, "_blank")}
          >
            <AllInboxIcon className="pop-list-icon" />
            <SystemLabel name="StagePage" />
          </button>
          <button
            className="moderator-page-to-btn"
            onClick={() =>
              window.open(
                `${window.location.origin}${!window.location.toString().includes("localhost") ? "/interaction" : ""}/digitalarena/${eventCode}?clientkey=${props.tickCode}${securityHelper.createGuid()}`,
                "_blank"
              )
            }
          >
            {" "}
            <MeetingRoomIcon style={{ marginRight: 6 }} className="pop-list-icon" /> <SystemLabel name="DigitalMeetingPage" />
          </button>
          <span style={{ margin: "0px 10px", color: "#d2d5d3F" }}>|</span>
          {breakouts.length > 0 ? (
            <PopList tooltipText={"Breakouts"} icon={<EventNoteIcon />}>
              <div className="pop-list" style={{ minWidth: 300, maxWidth: 310 }}>
                {breakouts
                  .sort((a, b) => {
                    return a.start - b.start;
                  })
                  .map((b, i) => {
                    return (
                      <React.Fragment key={i}>
                        <Row>
                          <Col>
                            <div
                              className="list-option"
                              onClick={() => window.open(`${window.location.origin}${!window.location.toString().includes("localhost") ? "/interaction" : ""}/${b.link}`, "_blank")}
                            >
                              {b.name}
                            </div>
                          </Col>
                        </Row>
                        <hr className="thin-hr" />
                      </React.Fragment>
                    );
                  })}
              </div>
            </PopList>
          ) : null}
          <IconButton
            onClick={() => window.open(`${window.location.origin}${!window.location.toString().includes("localhost") ? "/interaction" : ""}/editor/${eventCode}`, "_blank")}
            edge="start"
            color="inherit"
            aria-label="reset"
            style={{ margin: "0px", position: "relative" }}
          >
            <Tooltip title={<SystemLabel name="ModuleEditor" />}>
              <ViewCompactIcon />
            </Tooltip>
          </IconButton>
          <span style={{ margin: "0px 10px", color: "#d2d5d3F" }}>|</span>

          <PopList tooltipText={"OtherSettings"} icon={<MoreHorizIcon />}>
            <div className="pop-list" style={{ width: 400 }}>
              <Row style={{ margin: "0px" }}>
                <Col style={{ padding: "0px" }}>
                  <div className="list-option" onClick={() => exportParticipantExcel()}>
                    {" "}
                    <Row>
                      <Col className="col-10" style={{ display: "flex" }}>
                        <GetAppIcon className="pop-list-icon" />
                        <SystemLabel name="ExportStats" />
                      </Col>
                      <Col className="text-right col-2">
                        <GetAppIcon className="pop-list-icon" />
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>

              <hr className="thin-hr" />
              <Row style={{ margin: "0px" }}>
                <Col style={{ padding: "0px" }}>
                  <div className="list-option" onClick={() => exportActiveParticipantExcel()}>
                    <Row>
                      <Col className="col-10" style={{ display: "flex" }}>
                        <HowToVote className="pop-list-icon" />
                        <SystemLabel name="ActiveParticipants" />
                      </Col>
                      <Col className="text-right col-2">
                        <GetAppIcon className="pop-list-icon" />
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
              <hr className="thin-hr" />
              <Row style={{ margin: "0px" }}>
                <Col style={{ padding: "0px" }}>
                  <div
                    className="list-option"
                    onClick={() =>
                      window.open(`${window.location.origin}${!window.location.toString().includes("localhost") ? "/interaction" : ""}/session/chatmoderator/${eventCode}?code=${props.code}`, "_blank")
                    }
                  >
                    <Row>
                      <Col className="col-10" style={{ display: "flex" }}>
                        <RateReviewIcon className="pop-list-icon" />
                        <SystemLabel name="ChatModerator" />
                      </Col>
                      <Col className="text-right col-2">
                        <OpenInNewOutlinedIcon className="pop-list-icon" />
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
              <hr className="thin-hr" />
              <Row style={{ margin: "0px" }}>
                <Col style={{ padding: "0px" }}>
                  <div
                    className="list-option"
                    onClick={() =>
                      window.open(
                        `${window.location.origin}${!window.location.toString().includes("localhost") ? "/interaction" : ""}/digitalarena/mobile/${eventCode}?clientkey=${props.tickCode}${+new Date()}`,
                        "_blank"
                      )
                    }
                  >
                    <Row>
                      <Col className="col-10" style={{ display: "flex" }}>
                        <MobileFriendlyIcon className="pop-list-icon" />
                        <SystemLabel name="MobileRoom" />
                      </Col>
                      <Col className="text-right col-2">
                        <OpenInNewOutlinedIcon className="pop-list-icon" />
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
              <hr className="thin-hr" />
              <Row style={{ margin: "0px" }}>
                <Col className="col-12" style={{ padding: "0px" }}>
                  <div className="list-option" onClick={() => toggleModal()}>
                    {" "}
                    <RotateLeftIcon className="pop-list-icon" />
                    <SystemLabel name="Restore" />
                  </div>
                </Col>
              </Row>
              <hr className="thin-hr" />
              <Row style={{ margin: "0px" }}>
                <Col style={{ padding: "0px" }}>
                  <div className="list-option">
                    <Row>
                      <Col className="col-10" style={{ display: "flex" }}>
                        <EventBusyIcon className="pop-list-icon" />
                        <SystemLabel name="ArenaClosed" />
                      </Col>
                      <Col className="text-right col-2">
                        {props.arenaClosed}
                        <JirangoSwitch onChange={props.setArenaClosed} isChecked={props.arenaClosed == true} />
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </div>
          </PopList>
        </Col>
      </Toolbar>
      <ConfirmModal text="ResetEventDataInfo" header="AreYouSure" onCancel={toggleModal} onAction={reset} open={modalOpen} />
    </AppBar>
  );
}
